import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_COUNTDOWN_SET](state, p) {
    const drp = p.drp;
    drp.clock.sets.splice(0, 0, p.set);
  },
  [types.REMOVE_COUNTDOWN_SET](state, p) {
    const drp = p.drp;
    drp.clock.sets.splice(p.index, 1);
  },
  [types.SET_COUNTDOWN_BUFFER_DUR](state, p) {
    const drp = p.drp;
    drp.clock.sets[p.index].bufferDur = p.bufferDur;
  },
  [types.SET_COUNTDOWN_END_MSG](state, p) {
    const drp = p.drp;
    drp.clock.sets[p.index].endMessage = p.endMessage;
  },
  [types.SET_COUNTDOWN_RECUR](state, p) {
    const drp = p.drp;
    drp.clock.sets[p.index].recurring = p.recurring;
  },
  [types.SET_COUNTDOWN_BUFFER_TIME](state, p) {
    const drp = p.drp;
    drp.clock.sets[p.index].bufferTime = p.bufferTime;
  },
  [types.SET_COUNTDOWN_END_TIME](state, p) {
    const drp = p.drp;
    drp.clock.sets[p.index].endTime = p.endTime;
  },
  [types.SET_COUNTDOWN_FINAL_END](state, p) {
    const drp = p.drp;
    drp.clock.sets[p.index].end = p.end;
  },
  [types.SET_COUNTDOWN_END_DATE](state, p) {
    const drp = p.drp;
    drp.clock.sets[p.index].endDate.date = p.endDate;
  },
};

const actions = {
  addCountdownSet: ({ commit }, payload) => {
    commit(types.ADD_COUNTDOWN_SET, payload);
  },
  removeCountdownSet: ({ commit }, payload) => {
    commit(types.REMOVE_COUNTDOWN_SET, payload);
  },
  setCountdownBufferDur: ({ commit }, payload) => {
    commit(types.SET_COUNTDOWN_BUFFER_DUR, payload);
  },
  setCountdownEndMsg: ({ commit }, payload) => {
    commit(types.SET_COUNTDOWN_END_MSG, payload);
  },
  setCountdownRecur: ({ commit }, payload) => {
    commit(types.SET_COUNTDOWN_RECUR, payload);
  },
  setCountdownBufferTime: ({ commit }, payload) => {
    commit(types.SET_COUNTDOWN_BUFFER_TIME, payload);
  },
  setCountdownEndTime: ({ commit }, payload) => {
    commit(types.SET_COUNTDOWN_END_TIME, payload);
  },
  setCountdownEndDate: ({ commit }, payload) => {
    commit(types.SET_COUNTDOWN_END_DATE, payload);
  },
  setCountdownFinalEnd: ({ commit }, payload) => {
    commit(types.SET_COUNTDOWN_FINAL_END, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/countdown/vuex.js